/* Brand vote page UI: polls, this-or-that, drag-to-rank and the leaderboard.
   Each section is found by its data attribute and talks to window.BNVote. */

(function () {
  "use strict";
  var V = window.BNVote;
  if (!V) return;
  var REDUCED = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var registry = { polls: [], battles: [], ranks: [], rates: [] };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function status(root, text, bad) {
    var s = $(".bn-status", root);
    if (!s) return;
    s.textContent = text || "";
    s.classList.toggle("is-bad", !!bad);
  }
  function errText(e) {
    if (e && e.message === "cancelled") return "";
    if (e && e.code === "limit") return "You've played a lot of rounds. Thanks! Your picks are saved.";
    return "That didn't save. Check your connection and try again.";
  }
  function el(tag, cls) { var n = document.createElement(tag); n.className = cls; return n; }
  function pct(n, total) { return total ? Math.round((n / total) * 100) : 0; }

  // ---------------------------------------------------------------- polls
  $$("[data-bn-poll]").forEach(function (root) {
    var poll = root.dataset.bnPoll;
    var always = root.dataset.bnShow === "always";
    var opts = $$(".bn-option", root);
    registry.polls.push({ id: poll, title: root.dataset.bnTitle, items: opts.map(function (o) {
      return { id: o.dataset.id, label: o.dataset.label, img: o.dataset.thumb };
    }) });

    function paint(res, mine) {
      var tally = (res && res.polls[poll]) || {};
      var total = 0; Object.keys(tally).forEach(function (k) { total += tally[k]; });
      var picked = mine && mine.votes ? mine.votes[poll] : null;
      var show = always || !!picked;
      root.classList.toggle("has-results", show);
      var lead = 0; opts.forEach(function (o) { lead = Math.max(lead, tally[o.dataset.id] || 0); });
      opts.forEach(function (o) {
        var n = tally[o.dataset.id] || 0;
        var p = pct(n, total);
        o.classList.toggle("is-picked", picked === o.dataset.id);
        o.classList.toggle("is-leading", show && total > 0 && n === lead && n > 0);
        $(".bn-bar i", o).style.transform = "scaleX(" + (show ? p / 100 : 0) + ")";
        $(".bn-pct", o).textContent = show ? p + "%" : "";
        $(".bn-count", o).textContent = show ? n + (n === 1 ? " vote" : " votes") : "";
        var b = $(".bn-vote-btn", o);
        b.textContent = picked === o.dataset.id ? "Your pick" : (picked ? "Switch to this" : b.dataset.label);
        b.setAttribute("aria-pressed", String(picked === o.dataset.id));
      });
      var t = $(".bn-total", root);
      if (t) t.textContent = show && total ? total.toLocaleString() + (total === 1 ? " vote" : " votes") + " so far" : "";
    }
    V.onResults(paint);

    opts.forEach(function (o) {
      $(".bn-vote-btn", o).addEventListener("click", function () {
        if (V.mine().votes[poll] === o.dataset.id) return;
        status(root, "Saving your vote…");
        V.vote(poll, o.dataset.id, o.dataset.label).then(function () {
          status(root, "Vote counted for " + o.dataset.label + ". You can switch any time.");
        }).catch(function (e) { status(root, errText(e), true); });
      });
    });
  });

  // -------------------------------------------------------- this or that
  $$("[data-bn-battle]").forEach(function (root) {
    var game = root.dataset.bnBattle;
    var items = JSON.parse($("script[type='application/json']", root).textContent || "[]");
    registry.battles.push({ id: game, title: root.dataset.bnTitle, items: items });
    if (items.length < 2) return;
    var stage = $(".bn-tot-stage", root);
    var sides = $$(".bn-tot-pick", root);
    var counter = $(".bn-tot-count", root);
    var pair = [];
    var seen = {};
    var busy = false;
    var played = 0;

    function key(a, b) { return [a.id, b.id].sort().join("|"); }
    function next() {
      var tries = 0, a, b;
      do {
        a = items[Math.floor(Math.random() * items.length)];
        b = items[Math.floor(Math.random() * items.length)];
        tries++;
      } while ((a === b || (seen[key(a, b)] && tries < 60)) && tries < 80);
      if (a === b) b = items[(items.indexOf(a) + 1) % items.length];
      pair = [a, b];
      sides.forEach(function (s, i) {
        var it = pair[i];
        $("img", s).src = it.img;
        $("img", s).alt = it.label;
        $(".bn-tot-label", s).textContent = it.label;
        s.setAttribute("aria-label", "Pick " + it.label);
        s.classList.remove("is-win", "is-lose");
      });
      if (!REDUCED) { stage.classList.remove("swap"); void stage.offsetWidth; stage.classList.add("swap"); }
    }
    function updateCount() {
      var total = Math.max(played, V.mine().battles || 0);
      counter.textContent = total ? total + (total === 1 ? " pick made" : " picks made") : "Tap the one you'd grab first";
    }
    V.onResults(updateCount);

    sides.forEach(function (s, i) {
      s.addEventListener("click", function () {
        if (busy) return;
        busy = true;
        var w = pair[i], l = pair[1 - i];
        V.battle(game, w, l).then(function () {
          seen[key(w, l)] = true; played++;
          sides[i].classList.add("is-win"); sides[1 - i].classList.add("is-lose");
          status(root, "");
          updateCount();
          setTimeout(function () { busy = false; next(); }, REDUCED ? 0 : 420);
          if (played % 5 === 0) V.refresh();
        }).catch(function (e) { busy = false; status(root, errText(e), true); });
      });
    });
    var skip = $(".bn-tot-skip", root);
    if (skip) skip.addEventListener("click", next);
    next();
  });

  // ------------------------------------------------------------- ranking
  $$("[data-bn-rank]").forEach(function (root) {
    var poll = root.dataset.bnRank;
    var list = $(".bn-rank-list", root);
    var rows = $$(".bn-rank-row", list);
    registry.ranks.push({ id: poll, title: root.dataset.bnTitle, items: rows.map(function (r) {
      return { id: r.dataset.id, label: r.dataset.label, img: r.dataset.thumb };
    }) });

    function renumber() {
      $$(".bn-rank-row", list).forEach(function (r, i) {
        $(".bn-rank-n", r).textContent = i + 1;
        $(".bn-up", r).disabled = i === 0;
        $(".bn-down", r).disabled = i === rows.length - 1;
      });
    }
    function move(row, dir) {
      var sib = dir < 0 ? row.previousElementSibling : row.nextElementSibling;
      if (!sib) return;
      if (dir < 0) list.insertBefore(row, sib); else list.insertBefore(sib, row);
      renumber();
      $(dir < 0 ? ".bn-up" : ".bn-down", row).focus();
    }
    rows.forEach(function (r) {
      $(".bn-up", r).addEventListener("click", function () { move(r, -1); });
      $(".bn-down", r).addEventListener("click", function () { move(r, 1); });
    });

    // Pointer drag (mouse + touch) by the handle.
    var drag = null;
    list.addEventListener("pointerdown", function (e) {
      var h = e.target.closest(".bn-grip");
      if (!h) return;
      var row = h.closest(".bn-rank-row");
      e.preventDefault();
      drag = { row: row, id: e.pointerId };
      row.classList.add("is-drag");
      h.setPointerCapture(e.pointerId);
    });
    list.addEventListener("pointermove", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var y = e.clientY;
      var others = $$(".bn-rank-row", list).filter(function (r) { return r !== drag.row; });
      var before = others.find(function (r) { var b = r.getBoundingClientRect(); return y < b.top + b.height / 2; });
      if (before) { if (before !== drag.row.nextElementSibling) list.insertBefore(drag.row, before); }
      else if (list.lastElementChild !== drag.row) list.appendChild(drag.row);
      renumber();
    });
    function end() { if (drag) { drag.row.classList.remove("is-drag"); drag = null; } }
    list.addEventListener("pointerup", end);
    list.addEventListener("pointercancel", end);

    function paint(res, mine) {
      var mineOrder = mine && mine.ranks ? mine.ranks[poll] : null;
      root.classList.toggle("has-ranked", !!mineOrder);
      var btn = $(".bn-rank-submit", root);
      btn.textContent = mineOrder ? "Update my ranking" : btn.dataset.label;
      if (mineOrder && !root.dataset.restored) {
        root.dataset.restored = "1";
        mineOrder.forEach(function (id) { var r = rows.find(function (x) { return x.dataset.id === id; }); if (r) list.appendChild(r); });
        renumber();
      }
    }
    V.onResults(paint);
    $(".bn-rank-submit", root).addEventListener("click", function () {
      var items = $$(".bn-rank-row", list).map(function (r) { return { id: r.dataset.id, label: r.dataset.label }; });
      status(root, "Saving your ranking…");
      V.rank(poll, items).then(function () {
        status(root, "Ranking saved. " + items[0].label + " is your number one.");
      }).catch(function (e) { status(root, errText(e), true); });
    });
    renumber();
  });

  // ------------------------------------------- rate each design + favorite
  // Every design gets its own thumbs up/down (poll "like-<design>", options
  // up/down) so a weak design shows up even if nobody's favorite is close.
  // The favorite is a normal one-pick poll across all designs.
  $$("[data-bn-rate]").forEach(function (root) {
    var favPoll = root.dataset.favPoll;
    var prefix = root.dataset.likePrefix;
    var tabs = $$(".vote-tab");
    if (!tabs.length) return;
    var designs = tabs.map(function (t) {
      var img = $("img", t);
      return { id: t.dataset.id, label: t.textContent.trim(), img: img ? img.getAttribute("src") : "" };
    });
    registry.polls.push({ id: favPoll, title: root.dataset.bnTitle, items: designs });
    registry.rates.push({ prefix: prefix, items: designs });
    tabs.forEach(function (t) { t.append(el("span", "bn-tab-mark")); });

    var thumbs = $$(".bn-thumb", root);
    var fav = $(".bn-fav", root);
    var result = $(".bn-rate-result", root);
    var progress = $(".bn-rate-progress", root);
    var nextBtn = $(".bn-rate-next", root);
    var sel = $(".vote-tab[aria-selected='true']");
    var current = sel ? sel.dataset.id : designs[0].id;
    var lastRes = null;

    function find(id) { return designs.find(function (d) { return d.id === id; }); }
    function unrated(mine) {
      var votes = (mine && mine.votes) || {};
      return designs.filter(function (d) { return !votes[prefix + d.id]; });
    }

    function paint(res, mine) {
      lastRes = res;
      var votes = (mine && mine.votes) || {};
      var mineV = votes[prefix + current];
      var myFav = votes[favPoll];
      thumbs.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.v === mineV)); });
      fav.setAttribute("aria-pressed", String(myFav === current));
      $(".bn-star", fav).textContent = myFav === current ? "★" : "☆";
      $(".bn-fav-text", fav).textContent = myFav === current ? "Your favorite" : (myFav ? "Make this my favorite instead" : "Make it my favorite");

      var t = (res && res.polls[prefix + current]) || {};
      var up = t.up || 0, n = up + (t.down || 0);
      result.hidden = !mineV || !n;
      result.textContent = n ? pct(up, n) + "% love it · " + n + (n === 1 ? " rating" : " ratings") : "";

      tabs.forEach(function (tab) {
        var v = votes[prefix + tab.dataset.id];
        var m = $(".bn-tab-mark", tab);
        m.textContent = (votes[favPoll] === tab.dataset.id ? "★ " : "") + (v === "up" ? "👍" : v === "down" ? "👎" : "");
      });

      var left = unrated(mine);
      var done = designs.length - left.length;
      progress.textContent = done === designs.length
        ? (myFav ? "All rated and your favorite is in. Thank you!" : "All rated. Now star your favorite.")
        : "You've rated " + done + " of " + designs.length + " designs.";
      nextBtn.hidden = !mineV || !left.length;
      if (left.length && left[0].id !== current) nextBtn.textContent = "Next: " + left[0].label + " →";
      else if (left.length > 1) nextBtn.textContent = "Next: " + left[1].label + " →";
    }
    V.onResults(paint);
    document.addEventListener("bn:design", function (e) {
      current = e.detail.id;
      status(root, "");
      paint(lastRes, V.mine());
    });

    thumbs.forEach(function (b) {
      b.addEventListener("click", function () {
        var d = find(current), v = b.dataset.v;
        if (V.mine().votes[prefix + d.id] === v) return;
        status(root, "Saving…");
        V.vote(prefix + d.id, v, d.label + ": " + (v === "up" ? "Love it" : "Not for me")).then(function () {
          status(root, v === "up" ? "Noted: you love " + d.label + "." : "Noted: " + d.label + " isn't for you.");
        }).catch(function (e) { status(root, errText(e), true); });
      });
    });
    fav.addEventListener("click", function () {
      var d = find(current);
      if (V.mine().votes[favPoll] === d.id) return;
      status(root, "Saving…");
      V.vote(favPoll, d.id, d.label).then(function () {
        status(root, d.label + " is your favorite. You can change it any time.");
      }).catch(function (e) { status(root, errText(e), true); });
    });
    nextBtn.addEventListener("click", function () {
      var left = unrated(V.mine()).filter(function (d) { return d.id !== current; });
      if (!left.length) return;
      var tab = tabs.find(function (x) { return x.dataset.id === left[0].id; });
      tab.click();
      $(".vote-tabs").scrollIntoView({ block: "start", behavior: REDUCED ? "auto" : "smooth" });
    });
  });

  // ---------------------------------------------------------- leaderboard
  $$("[data-bn-leaderboard]").forEach(function (root) {
    var wrap = $(".bn-lb-grid", root);
    function card(title, kind, rows, note) {
      var max = rows.length ? rows[0].v : 0;
      var c = document.createElement("article");
      c.className = "bn-lb-card";
      c.innerHTML = '<p class="bn-lb-kind"></p><h3></h3><ol></ol><p class="bn-lb-note"></p>';
      $(".bn-lb-kind", c).textContent = kind;
      $("h3", c).textContent = title;
      $(".bn-lb-note", c).textContent = note;
      var ol = $("ol", c);
      rows.slice(0, 5).forEach(function (r, i) {
        var li = document.createElement("li");
        li.innerHTML = '<span class="bn-lb-n"></span>' + (r.img ? '<img alt="" width="28" height="56" loading="lazy">' : "") +
          '<span class="bn-lb-name"></span><span class="bn-lb-v"></span><span class="bn-lb-bar"><i></i></span>';
        $(".bn-lb-n", li).textContent = i + 1;
        if (r.img) $("img", li).src = r.img;
        $(".bn-lb-name", li).textContent = r.label;
        $(".bn-lb-v", li).textContent = r.text;
        $(".bn-lb-bar i", li).style.transform = "scaleX(" + (max ? r.v / max : 0) + ")";
        ol.appendChild(li);
      });
      if (!rows.length) { var e = document.createElement("li"); e.className = "bn-lb-empty"; e.textContent = "No votes yet. Be the first."; ol.appendChild(e); }
      return c;
    }
    V.onResults(function (res) {
      var cards = [];
      registry.rates.forEach(function (g) {
        var ratings = 0;
        var rows = g.items.map(function (it) {
          var t = res.polls[g.prefix + it.id] || {}, up = t.up || 0, n = up + (t.down || 0);
          ratings += n;
          return { label: it.label, img: it.img, v: n ? up / n : 0, n: n, text: n ? pct(up, n) + "% love it" : "" };
        }).filter(function (r) { return r.n; }).sort(function (a, b) { return b.v - a.v; });
        cards.push(card("Can designs", "Thumbs up", rows, ratings ? ratings.toLocaleString() + " ratings · share of people who love each one" : ""));
      });
      registry.polls.forEach(function (p) {
        var t = res.polls[p.id] || {}, total = 0;
        Object.keys(t).forEach(function (k) { total += t[k]; });
        var rows = p.items.map(function (it) { var n = t[it.id] || 0; return { label: it.label, img: it.img, v: n, text: pct(n, total) + "%" }; })
          .filter(function (r) { return r.v > 0; }).sort(function (a, b) { return b.v - a.v; });
        cards.push(card(p.title, "Poll", rows, total ? total.toLocaleString() + (total === 1 ? " vote" : " votes") : ""));
      });
      registry.ranks.forEach(function (p) {
        var t = res.ranks[p.id] || {}, voters = 0;
        var rows = p.items.map(function (it) { var r = t[it.id]; if (r) voters = Math.max(voters, r.n); return { label: it.label, img: it.img, v: r ? r.pts : 0, text: r ? r.pts + " pts" : "" }; })
          .filter(function (r) { return r.v > 0; }).sort(function (a, b) { return b.v - a.v; });
        cards.push(card(p.title, "Ranking", rows, voters ? voters.toLocaleString() + " rankings · 1st place earns the most points" : ""));
      });
      registry.battles.forEach(function (g) {
        var t = res.battles[g.id] || {}, plays = 0;
        var rows = g.items.map(function (it) { var r = t[it.id]; if (r) plays += r.w; return { label: it.label, img: it.img, v: r && r.n ? r.w / r.n : 0, text: r && r.n ? pct(r.w, r.n) + "% wins" : "" }; })
          .filter(function (r) { return r.text; }).sort(function (a, b) { return b.v - a.v; });
        cards.push(card(g.title, "This or that", rows, plays ? plays.toLocaleString() + " picks · win rate in head-to-heads" : ""));
      });
      wrap.replaceChildren.apply(wrap, cards);
    });
  });
})();
